import { CraigslistFormattedJobMetadataState } from './craigslist-formated-job-metadata-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByObjectKey } from '../reducers/utils/state-manager';

const InitialState = {
  craigslistFormattedJobMetadataByJobId: {},
  craigslistFormattedJobMetadataStateByJobId: {},
};

export const craigslistFormattedJobMetadataReducer = (
  state: any = InitialState,
  action: Action,
): CraigslistFormattedJobMetadataState => {
  switch (action.type) {
    case STARTING('LOAD_FORMATTED_JOB_METADATA'): {
      const {
        payload: {
          args: { jobId },
        },
      } = action;
      return updateResourceByObjectKey(state, 'craigslistFormattedJobMetadataByJobId', jobId, true);
    }
    case SUCCESS('LOAD_FORMATTED_JOB_METADATA'): {
      const {
        payload: {
          args: { jobId },
          data,
        },
      } = action;
      return updateResourceByObjectKey(
        state,
        'craigslistFormattedJobMetadataByJobId',
        jobId,
        false,
        {
          [jobId]: data,
        },
      );
    }
    case FAILURE('LOAD_FORMATTED_JOB_METADATA'): {
      const {
        payload: {
          args: { jobId },
        },
      } = action;
      return updateResourceByObjectKey(
        state,
        'craigslistFormattedJobMetadataByJobId',
        jobId,
        false,
      );
    }
    case STARTING('CREATE_OR_UPDATE_FORMATTED_JOB_METADATA'): {
      const {
        payload: {
          args: { jobId },
        },
      } = action;
      return updateResourceByObjectKey(state, 'craigslistFormattedJobMetadataByJobId', jobId, true);
    }
    case SUCCESS('CREATE_OR_UPDATE_FORMATTED_JOB_METADATA'): {
      const {
        payload: {
          args: { jobId },
          data,
        },
      } = action;
      return updateResourceByObjectKey(
        state,
        'craigslistFormattedJobMetadataByJobId',
        jobId,
        false,
        {
          [jobId]: data.craigslistJobMetadata,
        },
      );
    }
    case FAILURE('CREATE_OR_UPDATE_FORMATTED_JOB_METADATA'): {
      const {
        payload: {
          args: { jobId },
        },
      } = action;
      return updateResourceByObjectKey(
        state,
        'craigslistFormattedJobMetadataByJobId',
        jobId,
        false,
      );
    }
    default: {
      return state;
    }
  }
};
